export default __webpack_public_path__ + "static/media/undo.9618f524.svg";